<template>
  <div
    class="i-btn font-16 font500 flex flex-col-center"
    :class="['i-btn-'+btnType,cusClass]"
    :style="[customStyle]"
    @click="handleClick"
  >
    <slot>
      <span>{{ text }}</span>
    </slot>
  </div>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: "确认",
    },
    width: {
      type: [String, Number],
      default: 158,
    },
    height: {
      type: [String, Number],
      default: 43,
    },
    btnType: {
      type: [Number, String],
      default: 2,
    },
    cusStyle:{
      type:Object,
      default:()=>{}
    },
    cusClass:{
      type:String,
      default:'flex-row-center'
    }
  },
  data() {
    return {};
  },
  computed: {
    customStyle() {
      const width = isNaN(this.width) ? this.width : this.width + "px";
      const height = isNaN(this.height) ? this.height : this.height + "px";
      
      return Object.assign({
        width: width,
        height: height
      },this.cusStyle)
    },
  },
  methods: {
    handleClick: function () {
      this.$emit("btn-click");
    },
  },
};
</script>
<style lang="less">
.i-btn {
  color: white;
  border-radius: 43px;
  &-1 {
    background: transparent url(../assets/help/i-btn-1.png) no-repeat center center;
  }
  &-2 {
    background: transparent url(../assets/help/i-btn-2.png) no-repeat center center;
  }
  &-3 {
    background: transparent url(../assets/help/i-btn-3.png) no-repeat center center;
  }
  &-4 {
    background: transparent url(../assets/help/i-btn-4.png) no-repeat center center;
  }
  &-1,&-2,&-3,&-4{
    background-size: 100% 100%;
  }
}
</style>